export const APERTURA = '00APE'
export const COMPRAS = '01CMP'
export const VENTAS = '02VTA'
export const COBRANZAS = '03COB'
export const DIARIO = '04DIA'
export const PLANILLA = '05PLA'
export const CAJA_EGRESOS = '06EGR'
export const BANCOS = '07BCO'
export const ENTREGAS = '08ENT'
export const DEPRECIACIONES = '70DEP'
export const DIFERENCIA_TCAMBIO = '99DIF'

export const __dictionary = {
  [APERTURA]: { id: APERTURA, nombre: 'Apertura' },
  [PLANILLA]: { id: PLANILLA, nombre: 'Plantilla' },
  [CAJA_EGRESOS]: { id: CAJA_EGRESOS, nombre: 'Caja-Egresos' },
  [BANCOS]: { id: BANCOS, nombre: 'Bancos' },
  [DEPRECIACIONES]: { id: DEPRECIACIONES, nombre: 'Depreciaciones' },
  [DIFERENCIA_TCAMBIO]: { id: DIFERENCIA_TCAMBIO, nombre: 'Diferencia por T.Cambio' },
  [VENTAS]: { id: VENTAS, nombre: 'VENTAS' },
  [COBRANZAS]: { id: COBRANZAS, nombre: 'COBRANZAS' },
  [COMPRAS]: { id: COMPRAS, nombre: 'COMPRAS' },
  [DIARIO]: { id: DIARIO, nombre: 'DIARIO' },
  [ENTREGAS]: { id: ENTREGAS, nombre: 'ENTREGAS' }
}

export const __array = [
  __dictionary[VENTAS],
  __dictionary[COBRANZAS],
  __dictionary[COMPRAS],
  __dictionary[DIARIO],
  __dictionary[ENTREGAS],
  __dictionary[APERTURA],
  __dictionary[PLANILLA],
  __dictionary[CAJA_EGRESOS],
  __dictionary[BANCOS],
  __dictionary[DEPRECIACIONES],
  __dictionary[DIFERENCIA_TCAMBIO]
]

export default Object.freeze({
  VENTAS,
  COBRANZAS,
  COMPRAS,
  ENTREGAS,
  DIARIO,
  CAJA_EGRESOS,
  BANCOS,
  __dictionary,
  __array
})
